<template>
  <div>
    <div class="filters">
      <el-select
          @change="changeFilter()"
          class="filters__select"
          v-model="device"
          placeholder="Название показателя"
          name=""
          type=""
          size="small"
      >
        <el-option
            v-for="(item, index) in chartData"
            :key="index"
            :label="item.title"
            :value="index"
        ></el-option>
      </el-select>
      <el-date-picker
          size="small"
          v-model="date"
          type="daterange"
          format="dd.MM.yyyy"
          placeholder="Выберите дату"
          unlink-panels
          range-separator="-"
          start-placeholder="С"
          end-placeholder="По"
          :picker-options="pickerOptions"
          class="filters__date-picker"
      />
    </div>

    <div class="indicators">
      <div class="indicators__date">{{ $root.dateDefault(date[0]) }} - {{ $root.dateDefault(date[1]) }} г</div>
      <div v-if="chartData[device]" class="indicators__title">{{ getChartData.title || '' }}</div>
      <div v-if="false" class="indicators__percent">23%</div>
    </div>

    <transition name="el-fade-in-linear">
      <chart v-if="!loading" :date="date" :chart-data="getChartData.items" class="chart"/>
    </transition>

    <el-table
        v-loading="loading"
        :show-header="false"
        :data="screenings"
        style="width: 100%"
        class="expand-table"
    >
      <el-table-column
      >
        <template slot-scope="scope">
          <div class="expand-table__title">{{ scope.row.title }}</div>
        </template>

      </el-table-column>
      <el-table-column align="right">
        <template slot-scope="scope">
          {{ $root.dateIso(scope.row.date, true) }}
        </template>
      </el-table-column>

    </el-table>

  </div>
</template>
<script>
import Chart from "@/components/dynamics/Chart.vue"
import {mapGetters} from "vuex";

export default {
  name: "Indicators",
  components: {
    Chart
  },
  data() {
    return {
      loading: false,
      device: 0,
      date: [new Date(new Date().setTime(new Date().getTime() - 3600 * 1000 * 24 * 30 * 6)), new Date()],
      screenings: [],
      chartData: [],
      pickerOptions: {
        shortcuts: [{
          text: 'Неделя',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', [start, end]);
          }
        },
          {
            text: 'Месяц ',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            }
          },
          {
            text: '3 месяца',
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            }
          }]
      },
    }
  },
  computed: {
    ...mapGetters("visit", {
      visit: "data",
    }),
    getChartData() {
      return (!this.chartData.length) ? [] : this.chartData[this.device]
    }
  },
  created() {
    this.loadLogic()
  },
  watch: {
    date() {
      this.loadLogic()
    },
    device () {

    }
  },
  methods: {
    loadLogic() {

      let params = {
        userId: this.visit?.user?.id,
        startDate: this.date[0],
        endDate: this.date[1],
      }
      this.loading = true

      this.$api.dynamics.getDynamics({params}).then((response) => {
        console.log(response.data)

        this.screenings = response.data.screenings
        this.chartData = response.data.data
      })
          .catch(() => {
            this.options = []
          })
          .finally(() => {
            this.loading = false
          })
    },
    changeFilter() {

    }
  }
}

</script>

<style lang="scss" scoped>
.filters {
  margin-top: 16px;
  width: 100%;

  display: flex;
  justify-content: start;
  align-items: center;
  gap: 12px;

  &__select {
    width: 245px;

    /deep/ .el-input__inner {
      padding: 15px 12px !important;
    }
  }

  &__date-picker {
    width: 245px;
  }
}

/deep/ .el-table .cell {
  padding-left: 0 !important;
  padding-right: 0 !important;
}

.chart {
  margin-top: 10px;
}

.indicators {
  margin-top: 18px;

  display: flex;
  align-items: center;
  justify-content: start;
  gap: 14px;

  font-weight: 600;
  font-size: 16px;
  line-height: 26px;


  &__date {

    color: #8E8E93;
  }

  &__title {

    color: #111111;
  }

  &__percent {
    color: #43D3B3;

  }
}


.expand-table {
  margin-top: 24px;


  font-size: 14px;
  line-height: 22px;
  color: #676767;


  &__title {
    color: #111111;
    padding: 6px 0;
  }
}

</style>